import { GetApp } from "../../App"
import { FieldFormat } from "../../App/Format"
import { useEditForm } from "../../App/useEditForm"
import { EditGroup } from "../../Components/EditGroup"
import { CruiseApi, ApiClient, ICruise, ICruiseResponse, ICruiseUpdateRequest } from "../../Types"
import { Block, BlockContainer, BlockField, BlockRow } from "../../Components/Block"
import { GetShipView } from "../ShipView"
import { useCruiseData } from "./DataContext"

export const CruiseEditViewData = {
  saveCruise(api: ApiClient, shipId: number, cruiseId: number, values: ICruiseUpdateRequest): Promise<ICruiseResponse> {
    return new CruiseApi(api).cruises.update({ params: { shipId, cruiseId }, body: values }).call();
  },
  // `title` is plain text (issue #529 consistency pass) -- the registered "text"
  // format kind, so it gets the shared "–" convention for a missing value but no
  // unit/locale formatting.
  fieldFormat(): FieldFormat {
    return {
      title: "text",
    };
  },
};

interface CruiseEditViewProps {
  cruise: ICruise;
}

export function CruiseEditView({ cruise }: CruiseEditViewProps) {
  const app = GetApp();
  const shipView = GetShipView();
  const { writers } = useCruiseData();
  const t = app.getT("CruiseEditView");
  const editableFields = [{ name: "title", default: "", type: "string" }];
  const formEditable = app.editable || shipView.shipCloudEditable;
  const { edited, onEdited, saveEdits } = useEditForm({
    update: writers.updateCruise,
  });

  return (
    <div className="CruiseEditView">
      <BlockContainer>
        <Block>
          <EditGroup buttonFirst={true} changed={edited} editable={formEditable} editableFields={editableFields} onSave={saveEdits}>
            <BlockRow>
              <BlockField label={t("title")} className="block_field_small_30">
                <input defaultValue={cruise.title} name="title" onChange={onEdited} readOnly={!formEditable} maxLength={40} />
              </BlockField>
            </BlockRow>
          </EditGroup>
        </Block>
      </BlockContainer>
    </div>
  );
}
